function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import position from 'polished/lib/shorthands/position';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    checked,
    disabled,
    focusVisible
  } = _ref;
  var theme = useTheme();
  var iconBackgroundColor = 'transparent';
  var iconBorderColor = theme.palette.neutral.default;
  var iconLabelColor = theme.palette.foreground.default;
  if (disabled) {
    iconBorderColor = theme.palette.foreground.disabled;
    iconLabelColor = theme.palette.foreground.disabled;
  }
  if (checked && disabled) {
    iconBackgroundColor = theme.palette.foreground.disabled;
    iconBorderColor = theme.palette.foreground.disabled;
  } else if (checked) {
    iconBackgroundColor = theme.palette.primary.default;
    iconBorderColor = theme.palette.primary.default;
  }
  return React.useMemo(() => ({
    root: _objectSpread(_objectSpread({
      alignItems: 'center',
      color: iconLabelColor,
      cursor: disabled ? 'default' : 'pointer',
      display: 'flex',
      flex: '0 0 100%',
      flexFlow: 'row wrap',
      userSelect: 'none',
      '.vn-radio-button__icon': {
        backgroundColor: iconBackgroundColor,
        border: "1px solid ".concat(iconBorderColor),
        borderRadius: '100%',
        boxSizing: 'border-box',
        height: theme.orbitalSix,
        marginRight: theme.orbitalThree,
        position: 'relative',
        transition: 'all 150ms',
        width: theme.orbitalSix,
        '&::after': _objectSpread(_objectSpread({
          border: "2px solid ".concat(theme.palette.primary.default),
          borderRadius: '100%',
          boxSizing: 'border-box',
          content: "' '",
          opacity: 0,
          transition: 'all 150ms',
          zIndex: 1
        }, position('absolute', '0')), focusVisible && _objectSpread({
          opacity: 1
        }, position('-4px'))),
        '&::before': {
          background: theme.palette.foreground.inverse,
          borderRadius: '100%',
          content: "' '",
          height: theme.orbitalThree,
          left: '50%',
          opacity: checked ? 1 : 0,
          position: 'absolute',
          top: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
          transition: 'opacity 150ms',
          width: theme.orbitalThree
        }
      },
      '&:hover > .vn-radio-button__icon': !disabled && {
        backgroundColor: checked ? theme.palette.primary.hover : theme.palette.neutral.backgroundLight,
        borderColor: checked ? theme.palette.primary.hover : theme.palette.neutral.hover
      },
      '&:active > .vn-radio-button__icon': !disabled && {
        backgroundColor: checked ? theme.palette.primary.active : theme.palette.neutral.background,
        borderColor: checked ? theme.palette.primary.active : theme.palette.neutral.active
      },
      '.vn-radio-button__input': _objectSpread({
        border: 0,
        cursor: 'inherit',
        height: '100%',
        margin: 0,
        opacity: 0,
        width: '100%',
        zIndex: 2
      }, position('absolute', 0)),
      '.vn-radio-button__span-text': {
        maxWidth: 'calc(100% - 36px)',
        verticalAlign: 'middle'
      }
    }, highContrastMediaQuery(theme)), theme.mode === 'contrast' && !disabled && {
      color: theme.palette.neutral.default,
      transition: 'color 150ms',
      '&:hover': {
        color: theme.palette.neutral.hover
      },
      '&:active': {
        color: theme.palette.neutral.active
      }
    })
  }), [checked, disabled, focusVisible, iconBackgroundColor, iconBorderColor, iconLabelColor, theme]);
};
export default useStyles;